"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const SpotsLeftIcon = createIcon({
  displayName: "SpotsLeftIcon",
  viewBox: "0 0 45 33",
  path: (
    <>
      <path
        d="M38.44,17.15c.32,0,.59-.26.59-.59s-.26-.59-.59-.59-.59.26-.59.59.26.59.59.59Z"
        fill="currentColor"
      />
      <path
        d="M38.44,9.49c.64,0,1.16-.52,1.16-1.16v-1.65h-2.33v1.65c0,.64.52,1.16,1.16,1.16Z"
        fill="currentColor"
      />
      <path
        d="M38.44,19.08c-.64,0-1.16.52-1.16,1.16s.52,1.16,1.16,1.16,1.16-.52,1.16-1.16-.52-1.16-1.16-1.16Z"
        fill="currentColor"
      />
      <path
        d="M41.54,6.67v1.65c0,1.71-1.39,3.09-3.1,3.09s-3.1-1.39-3.1-3.09v-1.65h-4.08v19.69h13.74V6.67h-3.46ZM38.44,23.34c-1.71,0-3.1-1.39-3.1-3.09,0-.9.39-1.71,1-2.28-.27-.4-.43-.88-.43-1.4,0-1.39,1.13-2.52,2.52-2.52s2.52,1.13,2.52,2.52c0,.52-.16,1-.43,1.4.62.57,1,1.38,1,2.28,0,1.71-1.39,3.09-3.1,3.09Z"
        fill="currentColor"
      />
      <path
        d="M6.47,13.65c-.64,0-1.16.52-1.16,1.16v3.4c0,.64.52,1.16,1.16,1.16s1.16-.52,1.16-1.16v-3.4c0-.64-.52-1.16-1.16-1.16Z"
        fill="currentColor"
      />
      <path
        d="M0,6.67v19.69h13.61V6.67H0ZM9.57,18.22c0,1.71-1.39,3.09-3.1,3.09s-3.1-1.39-3.1-3.09v-3.4c0-1.71,1.39-3.09,3.1-3.09s3.1,1.39,3.1,3.09v3.4Z"
        fill="currentColor"
      />
      <path
        d="M16.24,6.67v19.69h12.38V6.67h-12.38ZM25.6,18.22c0,1.71-1.39,3.09-3.1,3.09s-3.1-1.39-3.1-3.09v-3.4c0-1.71,1.39-3.09,3.1-3.09s3.1,1.39,3.1,3.09v3.4Z"
        fill="currentColor"
      />
      <path
        d="M22.5,13.65c-.64,0-1.16.52-1.16,1.16v3.4c0,.64.52,1.16,1.16,1.16s1.16-.52,1.16-1.16v-3.4c0-.64-.52-1.16-1.16-1.16Z"
        fill="currentColor"
      />
      <path
        d="M43.68,33H1.32c-.73,0-1.32-.59-1.32-1.32v-2.69h45v2.69c0,.73-.59,1.32-1.32,1.32Z"
        fill="currentColor"
      />
      <path
        d="M45,4.04H0V1.32C0,.59.59,0,1.32,0h42.36c.73,0,1.32.59,1.32,1.32v2.72Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default SpotsLeftIcon;
